export const currency = "Rs.";

export const whatsappNumber = "+923066223005";

export const whatsappMessage = (product) => ` Hi! I want to order:  ${product.title} - Rs.:${product.discount_price}  
 
 ${window.location.href}`;

export const offerTimer = "2025-12-26T09:47:00.000Z";

export const socialLinks = {
  "facebook": "https://www.facebook.com/astelecom6",
  "twitter": "https://twitter.com/",
  "instagram": "https://instagram.com/",
  "linkedin": "https://linkedin.com/company/",
  "youtube": "https://youtube.com/",
  "tiktok": "https://tiktok.com/",
  "whatsapp": "https://wa.me/+923066223005",
  "telegram": "https://t.me/"
};